export default __webpack_public_path__ + "static/media/loading.507f28c4.gif";